export const IMG_PATH = '//s.qunarzz.com/vacation_tuan/2022/dalian';